module.exports = __webpack_public_path__ + "img/LTS_ABSA_KKK.3fd34154.gif";